<div class="container-notyet">
	<div class="bg logo" (click)="reloadWindowWithoutCache()"></div>
	<h2>No puedes realizar esta acción.</h2>
	<p>Contacta con <a href="mailto:gerente@gescansl.com" target="_blank">Gescan</a> para más información.</p>
</div>